// Columbus Rail Ramps - STRICT SELECTION ONLY (No other options allowed)
// These are the ONLY 2 options for loaded container pickup/return
export const RAIL_RAMPS = [
  'CSX – Columbus Intermodal',
  'Norfolk Southern – Columbus Intermodal'
];

// Empty Container Depots - For empty termination (Import) or empty pickup (Export)
export const EMPTY_DEPOTS = [
  'C&K',
  'CSX Columbus Ohio',
  'Delong Depot',
  'GCI',
  'IMC/IOS',
  'Marble Cliff',
  'Norfolk Southern Rickenbacker',
  'Other (Enter custom depot below)'
];

// Columbus Terminal Coordinates (for distance calculation)
export const COLUMBUS_TERMINAL_COORDS = {
  latitude: 39.9495,
  longitude: -82.8814
};
